<template>
  <div>
    <v-app-bar app light color="white">
      <div class="d-flex align-center">
        <v-img contain :src="require('@/assets/logo.png')" transition="scale-transition" width="40"/>
        <h2 class="primaryLight--text pl-2">Dr. Asmah Health Hub</h2>
      </div>
      <v-spacer></v-spacer>

      <div class="d-none d-md-block">
        <v-btn v-for="item in navItems" :key="item.id" text color="primaryLight" @click="$vuetify.goTo(item.id)">{{item.title}}</v-btn>
      </div>

      <v-menu v-if="$vuetify.breakpoint.smAndDown" bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item v-for="item in navItems" :key="item.id">
            <v-list-item-title>
              <v-btn text color="primaryLight" @click="$vuetify.goTo(item.id)">{{item.title}}</v-btn>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- HOME SECTION-->
    <section class="carousel home" id="home">
      <v-container class="d-md-block pa-0">
        <v-row align="center" class="fill-height home__row" no-gutters justify="center">
            <v-col cols="12" class="col-lg-4 col-md-4 col-xs-12" height="50%" :class="{'align-self-end pa-0' : $vuetify.breakpoint.smAndDown}">
              <h1 class="carousel__text carousel__text-left">Health is</h1>
            </v-col>
            <v-col cols="12" class="col-lg-8 col-md-8 col-xs-12 carousel__left-col" :class="{'align-self-baseline' : $vuetify.breakpoint.smAndDown}">
              <div class="carousel__container">
                <div class="carousel__container-circle">
                  <v-carousel cycle height="auto" hide-delimiters :show-arrows="false" class="carousel__container-inner" >
                    <v-carousel-item v-for="(slide, i) in slides" :key="i">
                      <v-row class="fill-height" align="center" justify="center" >
                        <div class="carousel__text carousel__text-right">{{slide.text}}</div>
                      </v-row>
                    </v-carousel-item>
                  </v-carousel>
                </div>
              </div>
            </v-col>
        </v-row>
      </v-container>

    </section>

    <!-- ABOUT SECTION-->
    <section class="about cover-width" id="about">
      <v-container fluid class="pa-0">
        <v-row class="ma-0">
          <v-col class="col-md-6 col-sm-12 col-xs-12 pa-16" :class="{'py-16 px-10' : $vuetify.breakpoint.smAndDown}">
              <h1 class="section-maintitle--light">The Hub's values</h1>
              <p>Assalamualaikum and hello there, I'm Dr. Asmah!</p>
              <p>It has been a lifelong goal of mine to see our community to be aware of the importance of integrating health into our lifestyle.</p>
              <p>I hope that my <b>HealthHub</b> would help you own your personal health!</p>
              <v-btn color="white" large depressed class="mt-8 primaryLight--text" @click="$vuetify.goTo('#contact')">i want to know more!</v-btn>
          </v-col>
          <v-col class="spa-bg col-md-6 col-sm-12 col-xs-12 px-16"></v-col>
        </v-row>
      </v-container>
    </section>

    <!-- SERVICES SECTION -->
    <section class="services pt-3 pb-10 cover-width" id="services">
      <v-container  class="pa-16" :class="{'py-16 px-5' : $vuetify.breakpoint.smAndDown}">
        <h1 class="section-maintitle--dark section-maintitle--center">Let's act on it!</h1>
        <p class="services__desc--box text-center">Join us at...</p>
        <v-row class="services__bigbox">
          <v-col cols="12" lg="4" md="12" sm="12" v-for="(service, i) in services" :key="i">
            <div class="services__smallbox">
              <v-img :src="service.image" max-width="100" class="services__flower"></v-img>
              <div>
                <h3 class="services__title"><a :href="$vuetify.breakpoint.smAndDown ? service.mobileLink : service.link">{{service.text}}</a></h3>
                <p class="services__desc">{{service.description}}</p>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- TESTIMONIALS SECTION -->
    <section class="testimonials cover-width" id="testimonials">
      <v-container class="pa-16" :class="{'py-16 px-5' : $vuetify.breakpoint.smAndDown}">
        <h1 class="section-maintitle--light section-maintitle--center">The Hub's Experiences</h1>
        <v-carousel cycle hide-delimiter-background :show-arrows="false" class="mt-10 testimonials__carousel">
          <v-carousel-item v-for="(testimonial, i) in testimonials" :key="i">
            <v-sheet color="primaryLight">
              <v-row align="center">
                <v-col cols="12" md="3">
                  <v-img aspect-ratio="1" max-width="250" class="rounded-circle testimonials__img" :src="testimonial.image"></v-img>
                </v-col>
                <v-col cols="12" md="9">
                  <div class="white--text">
                    <p>"{{testimonial.message}}"</p>
                    <p class="pt-10 text-right">- <em>{{testimonial.client}}</em> -<p>
                    <p class="text-right">{{testimonial.credential}} <a class="white--text text-decoration-none" :href="testimonial.link" target="_blank">{{testimonial.instagram}}</a></p>
                  </div>
                </v-col>
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </v-container>
    </section>

    <!-- CONTACT SECTION -->
    <section class="contact cover-width " id="contact">
      <v-container fluid class="pa-0 ma-0">
        <v-row no-gutters>
          <v-col cols="12" md="6" sm="12" :class="{'py-10 px-5' : $vuetify.breakpoint.smAndDown, 'py-16 pl-16 d-flex' : $vuetify.breakpoint.mdAndUp}"  class="contact__left align-center">
            <div>
              <h1 class="section-maintitle--dark" :class="{'section-maintitle--center' : $vuetify.breakpoint.smAndDown}">Let's connect!</h1>
              <h3 :class="{'text-center' : $vuetify.breakpoint.smAndDown}">Follow me on Instagram! <v-icon color="primary">mdi-heart</v-icon> <a href="https://www.instagram.com/drasmah_healthhub" target="_blank">@drasmah_healthhub</a></h3>
            </div>
          </v-col>
          <v-col cols="12" md="6" sm="12" class="py-16 contact__right d-flex align-center">
            <v-btn color="primary" class="contact__btn" elevation="8" href="https://www.instagram.com/drasmah_healthhub" target="_blank"><v-icon class="mr-3">mdi-instagram</v-icon>MESSAGE ME!</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <v-fade-transition>
      <v-btn fixed dark fab bottom right color="primaryLight" class="d-md-none mb-10" v-if="fab" @click="scrollToElement">
        <v-icon class="white--text display-2">mdi-chevron-down</v-icon>
      </v-btn>
    </v-fade-transition>
  </div>
</template>

<script>
import * as easings from 'vuetify/es5/services/goto/easing-patterns'
export default {
  name: 'Home',
  mounted() {
    setInterval(() => { this.fab = true }, 1500)
  },
  data() {
    return {
      //navbar ease scrolling
      duration: 300,
      offset: 0,
      easing: 'easeInOutCubic',
      easings: Object.keys(easings),
      computed: {
        options () {
          return {
            duration: this.duration,
            offset: this.offset,
            easing: this.easing,
          }
        },
      },

      navItems: [
        { id: '#home', title: 'Home' },
        { id: '#about', title: 'About' },
        { id: '#services', title: 'Activities' },
        { id: '#testimonials', title: 'Testimonials' },
        { id: '#contact', title: 'Contact me' }
      ],

      fab: false,
      slides: [
        { text: 'Commitment' },
        { text: 'Celebrating Effort' },
        { text: 'Having Balance' },
        { text: 'Consistency' },
        { text: 'Being Whole' }
      ],
      services : [
        {
          text: 'The Bekam Hub',
          description: '...to book a private bekam session (women only).',
          link: '/checklist',
          mobileLink: '/checklist',
          image: require('@/assets/flower3.jpg')
        },
        {
          text: 'The Heal Hub',
          description: '...to seek advice from trusted health practitioners.',
          link: 'https://www.instagram.com/stories/highlights/17895856645517826/?hl=en',
          mobileLink: 'https://www.instagram.com/p/CEYVUbVBZmd/?igshid=1542a9q9nzkci',
          image: require('@/assets/flower2.jpg')
        },
        {
          text: 'The Chat Hub',
          description: '...to talk to trusted professionals.',
          link: 'https://www.instagram.com/stories/highlights/17901814684492051/?hl=en',
          mobileLink: ' https://www.instagram.com/p/CDX1z5VB6oQ/?igshid=158tl2cwusaip',
          image: require('@/assets/flower1.jpg')
         }
      ],
      testimonials : [
        {
          client: 'Wana M',
          message: "Alhamdulillah, just had bekam darah done with @drasmah_healthhub. As expected a wonderful visit! She listens to our health problems and genuinely wants to help and get us better. Looking forward to an improvement in the morning after a good night's sleep, InshaAllah.",
          credential: null,
          instagram: null,
          link: null,
          image: require('@/assets/client_1.jpg')
        },
        {
          client: 'Nadia',
          message: "Had my third session yesterday and my extracted blood is a lot clearer than before. After my treatment, I had a cup of tea and then straight to bed... had a deep deep deep sleep and woke up in extra upbeat mood!",
          credential: 'makeup artisan',
          instagram: '@nadia.heidi',
          link: 'https://www.instagram.com/nadia.heidi/?hl=en',
          image: require('@/assets/client_2.jpg')
        },
        {
          client: 'Maggie',
          message: "So calmly and professionally done plus a good face-lifting bekam right after. Do give her a try!",
          credential: null,
          instagram: null,
          link: null,
          image: require('@/assets/client_3.jpg')
        },
        {
          client: 'Syura',
          message: "First time trying bekam and it was so relaxing! I don't know why I was so scared of it. Rate 10 out of 10 for my first time with @drasmah_healthhub.",
          credential: 'tempo instructor',
          instagram: '@jumpwithsyura',
          link: 'https://www.instagram.com/jumpwithsyura/?hl=en',
          image: require('@/assets/client_4.jpg')
        }
      ],
    }
  },
  methods: {
    scrollToElement() {
      window.scrollBy(0, 600);
    }
  }
}
</script>
